import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import CoursePicker from '../../../../components/CoursePicker';

class Picker extends Component {
  render () {
    return (
      <span>
        <Helmet>
          <title>British Sign Language Training and Qualification Courses Library - BSL Courses</title>
        </Helmet>
        <CoursePicker rootPath='/courses/picker' autoStart />
      </span>
    );
  }
}

export default Picker;



// WEBPACK FOOTER //
// ./src/views/Main/CourseInfo/Picker/index.js